//local
// const BASE_URL = `http://192.168.0.169/BestDayEver/public/api`;

// staging
const BASE_URL = `https://appdevprojects.co/BestDayEver/public/api`;

// Live
// const BASE_URL = `https://bestdayever.me/api`;

// export const API_KEY = `AIzaSyANds4Zpf9Vr0_4CpN7HXj9CElVMNi2NZI`;
//safe key

export const API_KEY = `AIzaSyC1RtO5Mfqi1jW-gw9qWK8SmuA-PLxUWDw`;

export const GOOGLE_MAPS_APIKEY = `AIzaSyC1RtO5Mfqi1jW-gw9qWK8SmuA-PLxUWDw`;
export const GOOGLE_CLIENT_ID =
  "939543390866-cf0i42gjmmfqs76ra6vk8tb8dm6m20u9.apps.googleusercontent.com";

const Apis = {
  // General
  getAllTypes: `${BASE_URL}/getAllTypes`,
  contactUs: `${BASE_URL}/contactUs`,

  // Auth
  login: `${BASE_URL}/web_login`,
  social_login: `${BASE_URL}/social_login`,
  getUserData: `${BASE_URL}/getUserData`,
  signup: `${BASE_URL}/signup`,
  logout: `${BASE_URL}/logout`,
  updateClientProfile: `${BASE_URL}/updateClientProfile`,
  updateVendorProfile: `${BASE_URL}/updateVendorProfile`,
  forgotPassword: `${BASE_URL}/web_forgotPassword`,
  verifyCode: `${BASE_URL}/verify`,
  changePassword: `${BASE_URL}/web_changePassword`,
  updatePassword: `${BASE_URL}/updatePassword`,
  getAllAdvertisements: `${BASE_URL}/getAllAdvertisements`,
  updateNotificationSetting: `${BASE_URL}/updateNotificationSetting`,
  updateRole: `${BASE_URL}/updateRole`,

  // Events
  events: `${BASE_URL}/events`,
  eventDetails: `${BASE_URL}/events/`,
  createEvent: `${BASE_URL}/createEvent`,
  updateEvent: `${BASE_URL}/updateEvent`,
  deleteEvent: `${BASE_URL}/deleteEvent`,
  createCountDown: `${BASE_URL}/createCountDown`,
  updateCountDown: `${BASE_URL}/updateCountDown`,
  budgets: `${BASE_URL}/budgets`,
  createBudgets: `${BASE_URL}/createBudgets`,
  updateBudgets: `${BASE_URL}/updateBudgets`,
  deleteBudget: `${BASE_URL}/deleteBudget`,
  deleteBudgetPayments: `${BASE_URL}/deleteBudgetPayments`,
  createBudgetCategory: `${BASE_URL}/createBudgetCategory`,
  getBudgetCategories: (id) => `${BASE_URL}/getBudgetCategories/${id}`,
  createBudgetPayments: `${BASE_URL}/createBudgetPayments`,
  budgetPayments: `${BASE_URL}/budgetPayments`,
  payEventBudget: `${BASE_URL}/payEventBudget`,
  vendorBudgetDetail: `${BASE_URL}/vendorBudgetDetail`,
  getUserEvents: `${BASE_URL}/getUserEvents`,
  weddingWall: `${BASE_URL}/weddingWall`,
  deletePlanningTemplate: `${BASE_URL}/deletePlanningTemplate`,

  //Payment
  subscriptions: `${BASE_URL}/subscriptions`,
  paymentCards: `${BASE_URL}/paymentCards`,
  storeCard: `${BASE_URL}/storeCard`,
  deleteCard: `${BASE_URL}/deleteCard`,
  buySubscription: `${BASE_URL}/buySubscription`,
  validatePromoCode: `${BASE_URL}/validatePromoCode`,

  //CheckList
  checklists: `${BASE_URL}/checklists`,
  createChecklist: `${BASE_URL}/createChecklist`,
  updateChecklist: `${BASE_URL}/updateChecklist`,
  updateChecklistStatus: `${BASE_URL}/updateChecklistStatus`,
  deleteChecklist: `${BASE_URL}/deleteChecklist`,
  calenderChecklists: `${BASE_URL}/calenderChecklists`,
  getEventGuests: `${BASE_URL}/getEventGuests`,

  //Inspirational Gallery
  createCategory: `${BASE_URL}/createCategory`,
  createGallery: `${BASE_URL}/createGallery`,
  updateGallery: `${BASE_URL}/updateGallery`,
  getGallery: `${BASE_URL}/getGallery`,
  getVendorGallery: `${BASE_URL}/getVendorGallery`,
  getGalleryByCatId_ImgName: `${BASE_URL}/getGalleryByCatId_ImgName`,
  getVendorGalleryByCatId_ImgName: `${BASE_URL}/getVendorGalleryByCatId_ImgName`,
  deleteGallery: `${BASE_URL}/deleteGallery`,
  deleteGalleryPhoto: `${BASE_URL}/deleteGalleryPhoto`,

  //Photos
  getAllGalleryPhotos: (next_page_url) =>
    next_page_url ? next_page_url : `${BASE_URL}/getAllGalleryPhotos`,
  getGalleryPhotos: (next_page_url) =>
    next_page_url ? next_page_url : `${BASE_URL}/getGalleryPhotos`,
  createGalleryPhotos: `${BASE_URL}/createGalleryPhotos`,
  getAllGalleryPhotosByUser: (next_page_url) =>
    next_page_url ? next_page_url : `${BASE_URL}/getAllGalleryPhotosByUser`,
  moveInspirationalPhotoToGallery: `${BASE_URL}/moveInspirationalPhotoToGallery`,
  getEventGalleryCategories: (event_id) =>
    `${BASE_URL}/getEventGalleryCategories/${event_id}`,
  createEventGalleryCategory: `${BASE_URL}/createEventGalleryCategory`,
  //Templates
  generalTemplates: `${BASE_URL}/generalTemplates`,
  templates: `${BASE_URL}/templates`,
  createTemplate: `${BASE_URL}/createTemplate`,
  deleteTemplate: `${BASE_URL}/deleteTemplate`,

  //wedding website
  weddingWebsite: (id) => `${BASE_URL}/weddingWebsite/${id}`,
  saveWeddingWebsite: (name) => `${BASE_URL}/saveWeddingWebsite${name}`,

  //Dashboard
  getClientDashboard: `${BASE_URL}/getClientDashboard`,
  getVendorDashboard: `${BASE_URL}/getVendorDashboard`,
  getGuestDashboard: `${BASE_URL}/getGuestDashboard`,

  //Reviews
  ClientReviewsToVendor: `${BASE_URL}/ClientReviewsToVendor`,
  getVendorResponseList: `${BASE_URL}/getVendorResponseList`,
  getClientResponseList: `${BASE_URL}/getClientResponseList`,
  VendorReviewsToClient: `${BASE_URL}/VendorReviewsToClient`,

  //Vendor
  createVendor: `${BASE_URL}/inviteUser`,
  getYourVendorDetail: `${BASE_URL}/getYourVendorDetail`,
  getYourVendor: (next_page_url) =>
    next_page_url ? next_page_url : `${BASE_URL}/getYourVendors`,
  findVendors: (next_page_url) =>
    next_page_url ? next_page_url : `${BASE_URL}/getFindVendors`,
  findVendorsbyCat: (next_page_url) =>
    next_page_url ? next_page_url : `${BASE_URL}/getFindVendorsByCat`,
  getSubVendor: `${BASE_URL}/getSubVendors`,
  removeSubVendor: `${BASE_URL}/deleteSubVendor`,
  GetWeddingPlannerTemplates: `${BASE_URL}/getWeddingPlannerTemplates`,

  getVendorDetail: `${BASE_URL}/getVendorDetail`,
  updateVendor: `${BASE_URL}/updateVendor`,
  vendorAddToEvent: `${BASE_URL}/vendorAddToEvent`,
  vendorRemoveToEvent: `${BASE_URL}/vendorRemoveToEvent`,
  getSubVendors: (next_page_url) =>
    next_page_url ? next_page_url : `${BASE_URL}/getSubVendors`,
  getVendorAllPhotos: `${BASE_URL}/getVendorAllPhotos`,
  createSubVendor: `${BASE_URL}/createSubVendor`,

  //GuestList
  GuestGroup: `${BASE_URL}/GuestGroup`,
  createGuestGroup: `${BASE_URL}/createGuestGroup`,
  deleteGuestGroup: `${BASE_URL}/deleteGuestGroup`,
  createEventGuest: `${BASE_URL}/createEventGuest`,
  eventGuests: `${BASE_URL}/eventGuests`,
  removeEventGuest: `${BASE_URL}/removeEventGuest`,
  updateEventGuest: `${BASE_URL}/updateEventGuest`,
  removeEventGuest: `${BASE_URL}/removeEventGuest`,

  // Menu
  eventMenus: `${BASE_URL}/eventMenus`,
  createEventMenu: `${BASE_URL}/createEventMenu`,

  // Venue
  createEventVenue: `${BASE_URL}/createEventVenue`,

  // Table
  createEventTable: `${BASE_URL}/createEventTable`,

  //Advertisement
  createAdvertisement: `${BASE_URL}/createAdvertisement`,
  getAdvertisement: `${BASE_URL}/advertisements`,
  updateAdvertisement: `${BASE_URL}/updateAdvertisement`,
  deleteAdvertisement: `${BASE_URL}/deleteAdvertisement`,

  //Pages
  getPagesInformation: `${BASE_URL}/pages`,
  eventTables: `${BASE_URL}/eventTables`,

  //Attendee
  eventAttendees: `${BASE_URL}/eventAttendees`,
  eventAttendeeDetail: `${BASE_URL}/eventAttendeeDetail`,
  updateAttendeesAndMeal: `${BASE_URL}/updateAttendeesAndMeal`,
  assignTable: `${BASE_URL}/assignTable`,
  downloadGuestPdf: `${BASE_URL}/downloadGuestPdf`,

  // RSVP
  createRsvp: `${BASE_URL}/createRsvp`,
  updateRsvp: `${BASE_URL}/updateRsvp`,
  rsvp: `${BASE_URL}/rsvp`,
  sendRsvp: `${BASE_URL}/sendRsvp`,

  //Vendor planning Templates
  getVendorEvent: `${BASE_URL}/getVendorEvent`,
  getPlanningTemplate: `${BASE_URL}/getPlanningTemplate`,
  createPlanningTemplate: `${BASE_URL}/createPlanningTemplate`,
  getSection: `${BASE_URL}/getSection`,
  getSubSections: `${BASE_URL}/getSubSections`,
  createSection: `${BASE_URL}/createSection`,

  // createSubSection: `${BASE_URL}/createSubSection`,
  updateSection: `${BASE_URL}/updateSection`,
  sortSections: `${BASE_URL}/sortSections`,
  deleteSection: `${BASE_URL}/deleteSection`,
  unlinkTemplateSection: `${BASE_URL}/unlinkTemplateSection`,
  getQuestion: `${BASE_URL}/getQuestion`,
  createQuestion: `${BASE_URL}/createQuestion`,
  updateQuestion: `${BASE_URL}/updateQuestion`,
  deleteQuestion: `${BASE_URL}/deleteQuestion`,
  getPlanningTemplatePublic: `${BASE_URL}/getPlanningTemplatePublic`,
  addToMyPlanning: `${BASE_URL}/addToMyPlanning`,
  saveTemplate: `${BASE_URL}/saveTemplate`,
  shareTemplateWithClient: `${BASE_URL}/shareTemplateWithClient`,
  associatePlanningTemplate: `${BASE_URL}/associatePlanningTemplate`,
  deAssociatePlanningTemplate: `${BASE_URL}/deAssociatePlanningTemplate`,
  downloadSectionPdf: `${BASE_URL}/downloadSectionPdf`,

  //Chat & ChatRoom
  createChatRoom: `${BASE_URL}/createChatRoom`,
  chatRooms: `${BASE_URL}/chatRooms`,
  chatRoomLists: `${BASE_URL}/chatRoomLists`,
  chatList: `${BASE_URL}/chatList`,
  getGuestList: `${BASE_URL}/getGuestList`,
  getVendorClients: `${BASE_URL}/getVendorClients`,
  getVendorList: `${BASE_URL}/getVendorList`,
  updateChatRoom: `${BASE_URL}/updateChatRoom`,

  chatRoomMessages: (next_page_url) =>
    next_page_url ? next_page_url : `${BASE_URL}/chatRoomMessages`,
  chatDetail: (next_page_url) =>
    next_page_url ? next_page_url : `${BASE_URL}/chatDetail`,
  sendGroupMessage: `${BASE_URL}/sendGroupMessage`,
  createChatRoomTopic: `${BASE_URL}/createChatRoomTopic`,
  getChatRoomMembers: `${BASE_URL}/getChatRoomMembers`,
  sendMessage: `${BASE_URL}/sendMessage`,
  vendorsChatList: `${BASE_URL}/vendorsChatList`,
  createChatList: `${BASE_URL}/createChatList`,

  //Event Reminder
  eventReminders: `${BASE_URL}/eventReminders`,
  createEventReminder: `${BASE_URL}/createEventReminder`,
  updateEventReminder: `${BASE_URL}/updateEventReminder`,
  deleteEventReminder: `${BASE_URL}/deleteEventReminder`,

  //Event Timeline
  createTimeline: `${BASE_URL}/createTimeline`,
  updateTimeline: `${BASE_URL}/updateTimeline`,
  eventTimelines: `${BASE_URL}/timelines`,
  deleteTimeline: `${BASE_URL}/deleteTimeline`,
  sortTimeline: `${BASE_URL}/sortTimeline`,
  downloadTimelinePdf: `${BASE_URL}/downloadTimelinePdf`,

  // Video Call
  generateGroupVideoCallToken: `${BASE_URL}/generateGroupVideoCallToken`,
  generateVideoCallToken: `${BASE_URL}/generateVideoCallToken`,
  // acceptCall: (chat_room_id) =>
  //   chat_room_id ? `${BASE_URL}/acceptCall?chat_room_id=${chat_room_id}` : `${BASE_URL}/acceptCall`,
  acceptCall: `${BASE_URL}/acceptCall`,
  declineCall: `${BASE_URL}/declineCall`,

  //Analytics
  getClientReviewsList: `${BASE_URL}/getClientReviewsList`,

  //Guest
  guestUpcomingEvents: `${BASE_URL}/guestUpcomingEvents`,
  getGuestRsvpDetails: `${BASE_URL}/getGuestRsvpDetails`,
  guestEventDetail: (id) => `${BASE_URL}/guestEventDetail/${id}`,
  createWeddingWall: `${BASE_URL}/createWeddingWall`,

  //notifications for all
  notifications: `${BASE_URL}/notifications`,
  unreadNotificationsCount: `${BASE_URL}/unreadNotificationsCount`,

  //View Result
  viewResult: `${BASE_URL}/viewResult`,

  //LiveStreaming
  eventBroadcast: `${BASE_URL}/eventBroadcast`,
  joinBroadcast: `${BASE_URL}/joinBroadcast`,
  leaveBroadcast: `${BASE_URL}/leaveBroadcast`,
  endBroadcast: `${BASE_URL}/endBroadcast`,

  //Client Planning form
  getTemplateByEvent: `${BASE_URL}/getTemplateByEvent`,
  getSectionsByTemplate: `${BASE_URL}/getSectionsByTemplate`,
  getSubSections: `${BASE_URL}/getSubSections`,
  clientSubmitAnswers: `${BASE_URL}/clientSubmitAnswers`,

  //Send Checklist
  checklistAssignToVendors: `${BASE_URL}/checklistAssignToVendors`,
  calenderChecklistsbyVendor: `${BASE_URL}/calenderChecklistsbyVendor`,

  //Submiy Rsvp
  guestSubmitRsvp: `${BASE_URL}/guestSubmitRsvp`,
  //Get All Vendors
  getUsersByRole: `${BASE_URL}/getUsersByRole`,

  //Playlist
  getVendorPlaylist: `${BASE_URL}/getVendorPlaylist`,
  getAdminPlaylist: `${BASE_URL}/getAdminPlaylist`,
  createPlaylist: `${BASE_URL}/createPlaylist`,
  deletePlaylist: `${BASE_URL}/deletePlaylist`,

  //Songs
  getYoutubeSongs: (query) =>
    `https://www.googleapis.com/youtube/v3/search?part=snippet&q=${query}&type=video&maxResults=10&key=${API_KEY}`,
  addPlaylistSong: `${BASE_URL}/createSong`,
  getPlaylistSongs: `${BASE_URL}/getPlaylistSongs`,
  deleteSong: `${BASE_URL}/deleteSong`,
  createTemplateSectionSong: `${BASE_URL}/createTemplateSectionSong`,
  getSpotifyPlaylist: `https://api.spotify.com/v1/me/playlists`,
  getSpotifyPlaylistSongs: (id) =>
    `https://api.spotify.com/v1/playlists/${id}/tracks`,
  deleteTemplateSectionSong: `${BASE_URL}/deleteTemplateSectionSong`,
  songIdeas: `${BASE_URL}/songIdeas`,
  updateSectionSongLikeStatus: `${BASE_URL}/updateSectionSongLikeStatus`,
  uploadBulkPlaylistSongs: `${BASE_URL}/createSongs`,
  getAllPlaylist: `${BASE_URL}/getAllPlaylist`,
  addPlaylistIdInTemplateSection: `${BASE_URL}/addPlaylistIdInTemplateSection`,
  createTemplateSectionSongs: `${BASE_URL}/createTemplateSectionSongs`,
  getSectionPlayList: `${BASE_URL}/getSectionPlayList`,
  bulkUploadSectionSongs: `${BASE_URL}/uploadBulkSongsInSection`,
};

export default Apis;
